import React, { useEffect, useState } from 'react';
import { PhoneIcon, LinkedinIcon, FacebookIcon, InstagramIcon, YoutubeIcon, MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [openMobileSection, setOpenMobileSection] = useState<string | null>(null);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleMouseEnter = (dropdown: string) => {
    setOpenDropdown(dropdown);
  };
  const handleMouseLeave = () => {
    setOpenDropdown(null);
  };
  const toggleMobileSection = (section: string) => {
    setOpenMobileSection(openMobileSection === section ? null : section);
  };
  return <header className={`sticky top-0 z-50 bg-white transition-shadow duration-300 ${isScrolled ? 'shadow-md' : 'border-b border-gray-200'}`} data-id="element-196">
      {/* Top Utility Bar - Desktop Only */}
      <div className="hidden lg:block bg-gray-50 border-b border-gray-200" data-id="element-197">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-198">
          <div className="flex items-center justify-between h-10" data-id="element-199">
            {/* Phone */}
            <a href="tel:2483800871" className="flex items-center text-sm text-navy hover:text-orange transition-colors font-medium" aria-label="Call Peak Machine Sales" data-id="element-200">
              <PhoneIcon className="w-4 h-4 mr-2" data-id="element-201" />
              <span data-id="element-202">(248) 380-0871</span>
            </a>

            {/* Social Icons */}
            <div className="flex items-center space-x-4" data-id="element-203">
              <a href="https://www.linkedin.com/company/peak-machine-sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="LinkedIn" data-id="element-204">
                <LinkedinIcon className="w-4 h-4" data-id="element-205" />
              </a>
              <a href="https://www.facebook.com/PeakMachineSales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Facebook" data-id="element-206">
                <FacebookIcon className="w-4 h-4" data-id="element-207" />
              </a>
              <a href="https://www.instagram.com/peak_machine_sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Instagram" data-id="element-208">
                <InstagramIcon className="w-4 h-4" data-id="element-209" />
              </a>
              <a href="https://www.youtube.com/channel/UCG3x08N2riAd1G2e9-driYA" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="YouTube" data-id="element-210">
                <YoutubeIcon className="w-4 h-4" data-id="element-211" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation Row */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="flex items-center justify-between h-20" data-id="element-213">
          {/* Logo + Company Name */}
          <a href="./" className="flex items-center space-x-3" data-id="element-214">
            <div className="w-12 h-12 bg-navy rounded flex items-center justify-center flex-shrink-0" data-id="element-215">
              <span className="text-white font-bold text-xs" data-id="element-216">PM</span>
            </div>
            <span className="text-navy font-bold text-lg hidden sm:block" data-id="element-217">
              Peak Machine Sales
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-218">
            {/* Primary Nav Links */}
            <nav className="flex items-center space-x-6" data-id="element-219">
              <a href="./" className="text-navy hover:text-orange transition-colors font-medium" data-id="element-220">
                Home
              </a>

              {/* About Dropdown */}
              <div className="relative" onMouseEnter={() => handleMouseEnter('about')} onMouseLeave={handleMouseLeave} data-id="element-221">
                <button className="flex items-center text-navy hover:text-orange transition-colors font-medium" data-id="element-222">
                  About
                  <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-223" />
                </button>
                {openDropdown === 'about' && <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-gray-200 py-2" data-id="element-224">
                    <a href="8.html" className="block px-4 py-2 text-navy hover:bg-gray-50 hover:text-orange transition-colors" data-id="element-225">
                      About Peak
                    </a>
                    <a href="66.html" className="block px-4 py-2 text-navy hover:bg-gray-50 hover:text-orange transition-colors" data-id="element-226">
                      FAQ
                    </a>
                    <a href="58.html" className="block px-4 py-2 text-navy hover:bg-gray-50 hover:text-orange transition-colors" data-id="element-227">
                      Industry News
                    </a>
                  </div>}
              </div>

              {/* Products Mega Menu */}
              <div className="relative" onMouseEnter={() => handleMouseEnter('products')} onMouseLeave={handleMouseLeave} data-id="element-228">
                <button className="flex items-center text-navy hover:text-orange transition-colors font-medium" data-id="element-229">
                  Products
                  <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-230" />
                </button>
                {openDropdown === 'products' && <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-[600px] bg-white rounded-lg shadow-xl border border-gray-200 p-6" data-id="element-231">
                    <div className="grid grid-cols-2 gap-8" data-id="element-232">
                      {/* Column 1: Product Lines */}
                      <div data-id="element-233">
                        <h3 className="text-sm font-bold text-navy uppercase mb-3" data-id="element-234">
                          Product Lines
                        </h3>
                        <div className="space-y-2" data-id="element-235">
                          <a href="BretonMachineTools.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-236">
                            Breton Machine Tools
                          </a>
                          <div data-id="element-237">
                            <a href="GFMachiningSolutions.html" className="block text-navy hover:text-orange transition-colors text-sm font-medium" data-id="element-238">
                              Used AgieCharmilles & Mikron Experts
                            </a>
                            <div className="ml-4 mt-1 space-y-1" data-id="element-239">
                              <a href="MikronHighSpeedMilling.html" className="block text-gray-600 hover:text-orange transition-colors text-sm" data-id="element-240">
                                Mikron Milling
                              </a>
                              <a href="18.html" className="block text-gray-600 hover:text-orange transition-colors text-sm" data-id="element-241">
                                AgieCharmilles EDM
                              </a>
                              <a href="LaserTexturing.html" className="block text-gray-600 hover:text-orange transition-colors text-sm" data-id="element-242">
                                Laser Ablation & Texturing
                              </a>
                              <a href="LaserMicromachining.html" className="block text-gray-600 hover:text-orange transition-colors text-sm" data-id="element-243">
                                Laser Micromachining
                              </a>
                              <a href="62.html" className="block text-gray-600 hover:text-orange transition-colors text-sm" data-id="element-244">
                                Tooling & Automation
                              </a>
                            </div>
                          </div>
                          <a href="SpinnerMachineTools.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-245">
                            SPINNER Milling & Turning
                          </a>
                          <a href="BodorLaserCutting.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-246">
                            Bodor Laser Cutting
                          </a>
                          <a href="Campro_Milling_Turning.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-247">
                            Campro Milling & Turning
                          </a>
                          <a href="https://seibu-america.com/" target="_blank" rel="noopener noreferrer" className="block text-navy hover:text-orange transition-colors text-sm font-medium" data-id="element-248">
                            Seibu America (Japanese Wire EDM){' '}
                            <span className="text-xs bg-orange text-white px-2 py-0.5 rounded ml-1" data-id="element-249">
                              NEW
                            </span>
                          </a>
                        </div>
                      </div>

                      {/* Column 2: By Category */}
                      <div data-id="element-250">
                        <h3 className="text-sm font-bold text-navy uppercase mb-3" data-id="element-251">
                          By Category
                        </h3>
                        <div className="space-y-2" data-id="element-252">
                          <a href="SpinnerMachineTools.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-253">
                            CNC Milling
                          </a>
                          <a href="SpinnerMachineTools.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-254">
                            CNC Turning
                          </a>
                          <a href="59m7/edm.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-255">
                            EDM - Electrical Discharge Machining
                          </a>
                          <a href="59m7/used-machines.html" className="block text-navy hover:text-orange transition-colors text-sm font-medium" data-id="element-256">
                            Used Wire & Sinker EDM
                          </a>
                          <a href="59m7/laser.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-257">
                            Laser
                          </a>
                          <a href="59m7/automation.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-258">
                            Machine Tool Automation
                          </a>
                          <a href="29.html" className="block text-navy hover:text-orange transition-colors text-sm" data-id="element-259">
                            EDM Parts & Consumables
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>

              {/* Contact Dropdown */}
              <div className="relative" onMouseEnter={() => handleMouseEnter('contact')} onMouseLeave={handleMouseLeave} data-id="element-260">
                <button className="flex items-center text-navy hover:text-orange transition-colors font-medium" data-id="element-261">
                  Contact
                  <ChevronDownIcon className="w-4 h-4 ml-1" data-id="element-262" />
                </button>
                {openDropdown === 'contact' && <div className="absolute top-full right-0 mt-2 w-72 bg-white rounded-lg shadow-xl border border-gray-200 py-2" data-id="element-263">
                    <a href="5.html" className="block px-4 py-2 text-navy hover:bg-gray-50 hover:text-orange transition-colors" data-id="element-264">
                      Contact Us
                    </a>
                    <a href="78.html" className="block px-4 py-2 text-navy hover:bg-gray-50 hover:text-orange transition-colors" data-id="element-265">
                      Selling USED EDM
                    </a>
                    <a href="https://www.gfms.com/en-us/service-success/helpline.html" target="_blank" rel="noopener noreferrer" className="block px-4 py-2 text-navy hover:bg-gray-50 hover:text-orange transition-colors" data-id="element-266">
                      GF Machining Solutions Service & Support
                    </a>
                  </div>}
              </div>
            </nav>

            {/* CTA Button */}
            <Button variant="primary" href="59m7/used-machines.html" size="md" data-id="element-267">
              Used Inventory
            </Button>
          </div>

          {/* Mobile: Phone Icon + CTA Button + Hamburger */}
          <div className="flex lg:hidden items-center space-x-3" data-id="element-268">
            <a href="tel:2483800871" className="text-navy p-2" aria-label="Call Peak Machine Sales" data-id="element-269">
              <PhoneIcon className="w-5 h-5" data-id="element-270" />
            </a>
            <Button variant="primary" href="59m7/used-machines.html" size="md" className="text-sm px-4 py-2" data-id="element-271">
              Used Inventory
            </Button>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-navy p-2" aria-label="Toggle menu" data-id="element-272">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-273" /> : <MenuIcon className="w-6 h-6" data-id="element-274" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu Drawer */}
        {isMobileMenuOpen && <div className="lg:hidden py-4 border-t border-gray-200 max-h-[80vh] overflow-y-auto" data-id="element-275">
            <nav className="flex flex-col space-y-2" data-id="element-276">
              <a href="./" className="text-navy hover:text-orange transition-colors font-medium py-2" data-id="element-277">
                Home
              </a>

              {/* About Mobile */}
              <div data-id="element-278">
                <button onClick={() => toggleMobileSection('about')} className="flex items-center justify-between w-full text-navy hover:text-orange transition-colors font-medium py-2" data-id="element-279">
                  About
                  <ChevronDownIcon className={`w-4 h-4 transition-transform ${openMobileSection === 'about' ? 'rotate-180' : ''}`} data-id="element-280" />
                </button>
                {openMobileSection === 'about' && <div className="ml-4 space-y-2 mt-2" data-id="element-281">
                    <a href="8.html" className="block text-navy hover:text-orange transition-colors py-1" data-id="element-282">
                      About Peak
                    </a>
                    <a href="66.html" className="block text-navy hover:text-orange transition-colors py-1" data-id="element-283">
                      FAQ
                    </a>
                    <a href="58.html" className="block text-navy hover:text-orange transition-colors py-1" data-id="element-284">
                      Industry News
                    </a>
                  </div>}
              </div>

              {/* Products Mobile */}
              <div data-id="element-285">
                <button onClick={() => toggleMobileSection('products')} className="flex items-center justify-between w-full text-navy hover:text-orange transition-colors font-medium py-2" data-id="element-286">
                  Products
                  <ChevronDownIcon className={`w-4 h-4 transition-transform ${openMobileSection === 'products' ? 'rotate-180' : ''}`} data-id="element-287" />
                </button>
                {openMobileSection === 'products' && <div className="ml-4 space-y-3 mt-2" data-id="element-288">
                    <div data-id="element-289">
                      <p className="text-xs font-bold text-gray-500 uppercase mb-2" data-id="element-290">
                        Product Lines
                      </p>
                      <div className="space-y-2" data-id="element-291">
                        <a href="BretonMachineTools.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-292">
                          Breton Machine Tools
                        </a>
                        <a href="GFMachiningSolutions.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm font-medium" data-id="element-293">
                          Used AgieCharmilles & Mikron Experts
                        </a>
                        <a href="SpinnerMachineTools.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-294">
                          SPINNER Milling & Turning
                        </a>
                        <a href="BodorLaserCutting.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-295">
                          Bodor Laser Cutting
                        </a>
                        <a href="Campro_Milling_Turning.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-296">
                          Campro Milling & Turning
                        </a>
                        <a href="https://seibu-america.com/" target="_blank" rel="noopener noreferrer" className="block text-navy hover:text-orange transition-colors py-1 text-sm font-medium" data-id="element-297">
                          Seibu America (Japanese Wire EDM){' '}
                          <span className="text-xs bg-orange text-white px-2 py-0.5 rounded ml-1" data-id="element-298">
                            NEW
                          </span>
                        </a>
                      </div>
                    </div>
                    <div data-id="element-299">
                      <p className="text-xs font-bold text-gray-500 uppercase mb-2" data-id="element-300">
                        By Category
                      </p>
                      <div className="space-y-2" data-id="element-301">
                        <a href="59m7/used-machines.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-302">
                          Used Wire & Sinker EDM
                        </a>
                        <a href="59m7/edm.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-303">
                          EDM
                        </a>
                        <a href="59m7/laser.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-304">
                          Laser
                        </a>
                        <a href="59m7/automation.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-305">
                          Automation
                        </a>
                        <a href="29.html" className="block text-navy hover:text-orange transition-colors py-1 text-sm" data-id="element-306">
                          EDM Parts & Consumables
                        </a>
                      </div>
                    </div>
                  </div>}
              </div>

              {/* Contact Mobile */}
              <div data-id="element-307">
                <button onClick={() => toggleMobileSection('contact')} className="flex items-center justify-between w-full text-navy hover:text-orange transition-colors font-medium py-2" data-id="element-308">
                  Contact
                  <ChevronDownIcon className={`w-4 h-4 transition-transform ${openMobileSection === 'contact' ? 'rotate-180' : ''}`} data-id="element-309" />
                </button>
                {openMobileSection === 'contact' && <div className="ml-4 space-y-2 mt-2" data-id="element-310">
                    <a href="5.html" className="block text-navy hover:text-orange transition-colors py-1" data-id="element-311">
                      Contact Us
                    </a>
                    <a href="78.html" className="block text-navy hover:text-orange transition-colors py-1" data-id="element-312">
                      Selling USED EDM
                    </a>
                    <a href="https://www.gfms.com/en-us/service-success/helpline.html" target="_blank" rel="noopener noreferrer" className="block text-navy hover:text-orange transition-colors py-1" data-id="element-313">
                      GF Machining Solutions Service
                    </a>
                  </div>}
              </div>

              {/* Social Icons Mobile */}
              <div className="flex items-center space-x-4 pt-4 border-t border-gray-200" data-id="element-314">
                <a href="https://www.linkedin.com/company/peak-machine-sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="LinkedIn" data-id="element-315">
                  <LinkedinIcon className="w-5 h-5" data-id="element-316" />
                </a>
                <a href="https://www.facebook.com/PeakMachineSales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Facebook" data-id="element-317">
                  <FacebookIcon className="w-5 h-5" data-id="element-318" />
                </a>
                <a href="https://www.instagram.com/peak_machine_sales/" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="Instagram" data-id="element-319">
                  <InstagramIcon className="w-5 h-5" data-id="element-320" />
                </a>
                <a href="https://www.youtube.com/channel/UCG3x08N2riAd1G2e9-driYA" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue transition-colors" aria-label="YouTube" data-id="element-321">
                  <YoutubeIcon className="w-5 h-5" data-id="element-322" />
                </a>
              </div>
            </nav>
          </div>}
      </div>
    </header>;
}